import { useSelector } from 'react-redux';
import { useUpdateEffect } from 'react-use';
import usePointsEarned from 'lib/hooks/usePointsEarned/usePointsEarned';
import { getPointsAmountInCash } from 'store/checkout/checkoutSelectors';
import { getTotalPayableAtBooking } from 'store/quote/quoteSelectors';

const useCheckoutPointsEarned = ({ pointsEarned: initialPointsEarned }) => {
  const totalPayableAtBooking = useSelector(getTotalPayableAtBooking);
  const pointsAmountInCash = useSelector(getPointsAmountInCash);
  const cashAmount = totalPayableAtBooking.minus(pointsAmountInCash);
  const { pointsEarned, onCashPaymentAmountChange } = usePointsEarned({ pointsEarned: initialPointsEarned });

  useUpdateEffect(() => {
    onCashPaymentAmountChange({ cashAmount });
  }, [cashAmount.toNumber()]);

  return { pointsEarned };
};

export default useCheckoutPointsEarned;
